import React from "react";
import Header from "./Header";
import HeaderNavigation from "../pages/header";
import Footer from "../pages/footer";
import StockTicker from "./Ticker";
export default function Layout({ children }) {
  return (
    <>
      <StockTicker />

      <HeaderNavigation />
      {children}
      <Footer />
    </>
  );
}
